import actionTypes from 'SRC/modules/redux/actionTypes'

export const setPackageCategoriesLoading = isLoading => ({
  type: actionTypes.SET_PACKAGE_CATEGORIES_LOADING,
  payload: isLoading
})
